// extracted by mini-css-extract-plugin
export default {"wrapper":"CutsceneText_wrapper__aGDuk","text":"CutsceneText_text__TL+rM"};